import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    isVisible: false,
    isLoading: false,
    hasError: false,
  }),
  getters: {
    getIsVisible: (state) => state.isVisible,
    getIsLoading: (state) => state.isLoading,
    getHasError: (state) => state.hasError,
  },
  actions: {
    setVisible(visible: boolean) {
      this.isVisible = visible;
    },
    setIsloading(loading: boolean) {
      this.isLoading = loading;
    },
    setHasError(error: boolean) {
      this.hasError = error;
    },
  },
});
